import React from "react";
import { EPDShuntingUnit } from "./EPDShuntingUnit";
import {
  SingleTrackAction,
  WithShuntingUnit,
  WithTrackAndGeometry,
} from "@opstel/query/v2/models/action";
import { TRACK_LINE_WIDTH } from "../core/styles";
import { calculatePositionOnTrack } from "../core/calculatePositionOnTrack";

export type TrackActionWithShuntingUnit = SingleTrackAction &
  WithShuntingUnit &
  WithTrackAndGeometry;
interface StandingTrainsProps {
  readonly action: TrackActionWithShuntingUnit;
}
export function StandingTrains({ action }: StandingTrainsProps): React.JSX.Element | null {
  if (!action.stablingInfraWithGeometry || !action.shuntingUnit) {
    return null;
  }
  const ptuPaths = calculatePositionOnTrack(
    action.stablingInfraWithGeometry,
    action.shuntingUnit,
    action.distanceToSource,
    action.orientation,
  );

  return (
    <EPDShuntingUnit
      orientation={action.orientation}
      shuntingUnit={action.shuntingUnit}
      planTrainUnitPaths={ptuPaths}
      trackLineWidth={TRACK_LINE_WIDTH}
    />
  );
}
